import { getSortedPosts, getTags } from '$lib/posts';
import type { Load } from '@sveltejs/kit';

export const load: Load = () => {
	return {
		posts: getSortedPosts(5),
		tags: getTags()
	};
};
